import './App.css';
//Importing Components
import {Header} from './components/Header'
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Menu } from './components/Menu';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
//Importing Script
import { ScriptComp } from './components/ScriptComp';

function App() {
  return (
    <>
      <Header/>
      <Hero/>
      <About/>
      <Menu/>
      <Contact/>
      <Footer/>
      <ScriptComp/>
    </>
  );
}

export default App;
